import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlReservationVoid } from './connectionData.tsx'

const useReservationVoid = () => {
  const [errorReservationVoid, setErrorReservationVoid] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const reservationVoid = async (_id: string, cause: string, by: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlReservationVoid()
      const res = await customPost<{ message: string }>(apiUrl, { _id, cause, by })
      setErrorReservationVoid(null)

      return res
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorReservationVoid(err)
      } else {
        setErrorReservationVoid(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorReservationVoid, loading, reservationVoid }
}
export default useReservationVoid
